import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManagementRoutingModule } from './user-management-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from '../shared/shared.module';
import { AddUserComponent } from './add-user/add-user.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UserManagementMainComponent } from './user-management-main/user-management-main.component';

@NgModule({
  imports: [
    CommonModule,
    UserManagementRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    LoadingModule
  ],
  declarations: [AddUserComponent, UsersListComponent, UserManagementMainComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AuthService]
})
export class UserManagementModule { }



// WEBPACK FOOTER //
// ./src/app/user-management/user-management.module.ts